import React, {useContext, useMemo} from "react";
import {ReactComponent as SearchIcon} from "../../../../../../../assets/images/phone-homepage/search.svg";
import {ReactComponent as ScanIcon} from "../../../../../../../assets/images/phone-homepage/scan.svg";
import {Tab, Tabs} from "../../../../../../components/base/Tabs";
import PhoneSimulatorHeader from "../../../../../../components/base/device-simulator/phone-entities/header";
import {UserHomepageControllerContext, UserHomepageStateContext} from "../../../../index";
import PhoneSimulatorScreenTopbar from "../../../../../../components/base/device-simulator/phone-entities/screen-topbar";
import {UserHomepageEventEmitter} from "../../../../models";

const UserPhoneHomepageHeader = () => {
    const controller = useContext(UserHomepageControllerContext);
    const state = useContext(UserHomepageStateContext);

    /**
     * Selects the given tab as the current tab of the homepage.
     * @param {Event} e
     * @param {number} value
     */
    const selectNewTab = (e, value) => {
        controller.selectTab(value, UserHomepageEventEmitter.view)
    }

    /**
     * Renders the tabs of this header.
     * @type {JSX.Element[]}
     */
    const tabs = useMemo(() =>
        state.updatedData?.tabs?.map(e => (
            <Tab
                key={e.id}
                value={e.id}
                label={e.name}
                id={e.phoneViewElementId}
            />
        )), [state.updatedData?.tabs])

    return (
        <>
            <PhoneSimulatorScreenTopbar/>
            <PhoneSimulatorHeader className={'header'}>
                <div className={'phone-topbar'}>
                    <div className={'input'}>
                        <SearchIcon/>
                        <p>
                            Part No, Order No, RGA
                        </p>
                    </div>
                    <div className={'scan'}>
                        <ScanIcon/>
                    </div>
                </div>
                {
                    tabs?.length > 1 &&
                    <div className='w-100'>
                        <Tabs
                            className={'tabs'}
                            value={state.selection.tabId ?? false}
                            onChange={selectNewTab}
                        >
                            {tabs}
                        </Tabs>

                    </div>
                }
            </PhoneSimulatorHeader>
        </>
    )
}

export default UserPhoneHomepageHeader;
